import Knife from "./datdrop-knife.png";
import Corona from "./corona.png";
import FlagYellow from "./flag-yellow.png";
import GunRose from "./gun-rose.png";
import KnifeBox from "./knife-box.png";
import CoverMan from "./cover-man.png";
import CoverGirl from "./cover-girl.png";
import OrangeStick from "./orange-stick.png";
import OrangeStickBlurSm from "./orange-stick-blur-sm.png";
import CaseGunOrange from "./case-gun-orange.png";
import CaseGunOrangeBlur from "./case-gun-orange-blur.png";
import YellowGun from "./yellow-gun.png";

const DatDropAnimatedBg = () => {
  return (
    <svg viewBox="0 0 1714 649" xmlns="http://www.w3.org/2000/svg">
      {/* LEFT SIDE */}
      <g transform="translate(.000001 0)">
        <image
          width="225"
          height="190"
          href={Corona.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(1 0 0 1 0.415418 503.431437)"
        />
      </g>
      <g transform="translate(.000001 0)" style={{ filter: "none" }}>
        <image
          width="260"
          height="325"
          href={CoverMan.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(1 0 0 1 200.0 140.0)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="112"
          height="96"
          href={CaseGunOrange.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(80.415418 330.431437) rotate(-30 56 48)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="30"
          height="16"
          href={OrangeStick.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(180 20) rotate(-100 56 48)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="120"
          height="90"
          href={Knife.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(1 0 0 1 60 150)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="130"
          height="115"
          href={KnifeBox.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(1 0 0 1 400 50)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="30"
          height="16"
          href={OrangeStickBlurSm.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(300 600) rotate(-90 0 0)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="16"
          height="8"
          href={OrangeStickBlurSm.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(50 470) rotate(0 0 0)"
        />
      </g>
      {/* MIDDLE SIDE */}
      <g transform="translate(.000001 0)">
        <image
          width="80"
          height="70"
          href={CaseGunOrangeBlur.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(1 0 0 1 500 520)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="18"
          height="12"
          href={OrangeStickBlurSm.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(1150 570) rotate(-90 0 0)"
        />
      </g>
      {/* RIGHT SIDE */}
      <g transform="translate(.000001 0)" style={{ filter: "none" }}>
        <image
          width="220"
          height="325"
          href={CoverGirl.src}
          preserveAspectRatio="xMidYMid meet"
          transform="matrix(1 0 0 1 1250.0 160.0)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="112"
          height="96"
          href={CaseGunOrange.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(1500 60) rotate(20 56 48)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="105"
          height="85"
          href={FlagYellow.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(1250 80) rotate(0 56 48)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="190"
          height="143"
          href={YellowGun.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(1500 320) rotate(0 56 48)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="205"
          height="165"
          href={GunRose.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(1400 480) rotate(0 56 48)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="30"
          height="16"
          href={OrangeStick.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(1500 470) rotate(220 0 0)"
        />
      </g>
      <g transform="translate(.000001 0)">
        <image
          width="30"
          height="16"
          href={OrangeStick.src}
          preserveAspectRatio="xMidYMid meet"
          transform="translate(1600 270) rotate(0 0 0)"
        />
      </g>
    </svg>
  );
};

export { DatDropAnimatedBg };
